import { AppContextProps } from "../AppContext";
import { DialogOptions } from "./DialogOptions";
import MenuDialogBase, { MenuDialogBaseProps } from "./MenuDialogBase";


export class MenuDialog {

  static Show(ctx: AppContextProps | null,
    options: DialogOptions,
    props?: Omit<MenuDialogBaseProps, 'open'>) {

    const dailog = ctx?.ShowDialog(MenuDialogBase, {

      options: options,
      fullWidth: true,
      dialogContentProps: { sx: { p: 0 } },
      ...props,

      onDialogResult(e) {// 注意! 要放在 ...props 後面覆寫事件

        props?.onDialogResult?.(e);
        if (e.IsCancelClose !== true) {
          dailog?.destroy();
          return
        }
      },
    });
  }
}